import React from "react";
import { Box, Typography } from "../../../common/MuiImports";

interface ModemAgreementProps {
  modemAgreement: string;
}

const ModemAgreement: React.FC<ModemAgreementProps> = ({ modemAgreement }) => {
  return (
    <Box
      sx={{
        mt: 4,
        mb: 4,
        p: 3,
        backgroundColor: "#f5f5f5",
        borderRadius: "4px",
        border: "1px solid #e0e0e0",
      }}
      data-test-id="modem-agreement-container"
    >
      <Typography
        variant="h6"
        sx={{
          color: "#545861",
          marginBottom: 2,
          fontWeight: "bold",
        }}
        data-test-id="modem-agreement-header"
      >
        Modem Agreement
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "#545861",
          lineHeight: "1.6",
          fontSize: "14px",
        }}
        data-test-id="modem-agreement-text"
      >
        {modemAgreement}
      </Typography>
    </Box>
  );
};

export default ModemAgreement;
